<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "ReinforcementFormMixin",
  computed: {
    ...mapState("reinforcementGenerate", {
      reinforcementInput: state => state.currentItem,
    }),
    ...mapGetters('stabSchematisation', {
      isLocked: "isLockedCurrent",
    }),
  },
  methods: {
    ...mapActions("reinforcementGenerate", {
      setNestedParameter: "setNestedParameter",
    }),
    onValueChanged({parameter, value}) {
      this.addDirty(this.reinforcementInput, parameter);
      this.setNestedParameter({
        item: this.reinforcementInput,
        parameter: parameter,
        value
      });
    },
    emptyDirtyItemsClass() {
      this.dirtyItems = [];
    },
  }
};
</script>
